import { Component, effect, input } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { WjChartModule } from '@grapecity/wijmo.angular2.chart'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { BaseComponent, ColumnChart, ListItem } from '../../../shared'
import { AutoSizeDirective } from '../../../shared/utility/auto-size.directive'

@Component({
    selector: 'app-projected-hours-chart',
    templateUrl: './projected-hours-chart.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, WjChartModule, AutoSizeDirective],
})
export class ProjectedHoursChartComponent extends BaseComponent {
    faSpinner = faSpinner
    active = input(1)

    activeJobsList = input<ListItem<string>[]>([])
    seriesTypes = [
        new ListItem(ProjectedHoursChartSeriesType.Total, 'Total'),
        new ListItem(ProjectedHoursChartSeriesType.Job, 'Job'),
        new ListItem(ProjectedHoursChartSeriesType.JobType, 'Job Type'),
        new ListItem(ProjectedHoursChartSeriesType.Phase, 'Phase'),
        new ListItem(ProjectedHoursChartSeriesType.PrDept, 'PR Dept'),
    ]
    selectedSeriesType = ProjectedHoursChartSeriesType.Total

    chartData!: ColumnChart

    constructor() {
        super()
        effect(() => {
            if (this.active() === 2) this.refresh()
        })
    }

    refresh() {
        if (this.active() !== 2) return
        const requestDto = {
            seriesType: this.selectedSeriesType,
            selectedJobs: this.activeJobsList()
                .filter(x => x.selected)
                .map(x => x.value),
        }
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(true, true, this.services.data.post('/api/ProjectedHours/GetHoursProjectionChart', requestDto))
                .subscribe({
                    next: result => {
                        console.log('result', result)
                        this.chartData = result[0]
                    },
                }),
        )
    }
}

export enum ProjectedHoursChartSeriesType {
    Total,
    Job,
    JobType,
    Phase,
    PrDept,
}
